export const APP_BUILD = "PROD";
export const APP_VERSION = "3.3.1";
